<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="arkCode" label="客户名称/代码" :rules="[{ required: true, message: '请选择' }]">
        <CusSelect appId="cos_fbu" v-model:value="editForm.arkCode" placeholder="请选择" @selectData="selectData" />
      </a-form-item>
      <a-form-item name="status" label="客户状态" :rules="[{ required: true, message: '请选择' }]">
        <a-select ref="select" v-model:value="editForm.status" placeholder="请选择">
          <!-- <a-select-option :value="BiOrderStatus.RUNNING">磨合</a-select-option> -->
          <a-select-option :value="BiOrderStatus.UP">上涨</a-select-option>
          <a-select-option :value="BiOrderStatus.DOWN">下降</a-select-option>
          <a-select-option :value="BiOrderStatus.FLAT">保持</a-select-option>
          <!-- <a-select-option :value="BiOrderStatus.LOSS">流失</a-select-option> -->
        </a-select>
      </a-form-item>
      <a-form-item name="floatPercent" label="浮动比例（%）" :rules="[{ required: true, message: '请输入' }]">
        <a-input-number v-model:value="editForm.floatPercent" :maxlength="10" placeholder="请输入" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import { addBiOrderStatus, updateBiOrderStatus } from '@/api/gucangSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { AddBiOrderStatusParams } from '@/typings/api/gucangSale'
import CusSelect from '@/components/CustomerCodeSelect/index.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { BiOrderStatus } from '../hooks/enum'
export default { name: 'editModal' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<AddBiOrderStatusParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: AddBiOrderStatusParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const selectData = (value: string) => {
  editForm.value.cosId = value
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId, floatPercent, status } = editForm.value
    const p = {
      arkCode,
      cosId,
      floatPercent,
      status
    }
    try {
      if (editForm.value.id) {
        await updateBiOrderStatus({ ...p, id: editForm.value.id })
      } else {
        await addBiOrderStatus(p)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
